<template>
  <div class="form-dynamix" v-loading="loading">
    <div class="columns is-gapless is-centered is-multiline" style="margin-bottom:0;">
      <div v-for="(item, index) in items" :key="index" class="column" :class="[{ 'is-12': !item.attributes.column }, item.attributes.column]">

        <div class="field">
          <div class="control has-icons-right">
            <!-- checkbox / radio label & default checkbox -->
            <p v-if="(item.attributes.type === 'checkbox' || item.attributes.type === 'radio')" class="label">
              <span v-if="item.attributes.title && !item.attributes.withDefault && !item.attributes.titleHidden">
                {{ item.attributes.title + (vuelidate.models[item.name].$params.hasOwnProperty('required') || vuelidate.models[item.name].$params.hasOwnProperty('required_custom') ? ' *' : '') }}
              </span>
              <label v-if="item.attributes.type === 'checkbox' && item.attributes.withDefault === true"
                :class="[item.attributes.type]" class="label default">
                <input type="checkbox" :name="[item.name]"
                  v-model="models[item.name]" v-if="!item.attributes.withDefaultHideInput"
                  @clicked="item.attributes.onChecked()" />
                {{ item.attributes.title + (vuelidate.models[item.name].$params.required ? ' *' : '') }}
              </label>
              <!-- <span>{{ models[item.name] }}</span> -->
            </p>

            <!-- dropdown -->
            <div v-if="item.attributes.type === 'dropdown'" style="margin-bottom:8px;">
              <label :class="[item.attributes.type]" :for="item.name">
                <span class="label">{{ item.attributes.title + (vuelidate.models[item.name].$params.required ? ' *' : '') }}</span>
              </label>
            </div>
            <div v-if="item.attributes.type === 'dropdown'" class="select">
              <select :class="[{ 'is-danger': vuelidate.models[item.name].$dirty && (models[item.name] == undefined || models[item.name] == 0 || models[item.name].length <= 0) && (vuelidate.models[item.name].$params.required && !vuelidate.models[item.name].required) }]"
              v-model="models[item.name]" style="position:relative;">
                <option v-for="option in item.attributes.options" :key="option.value" :value="option.value">
                  {{ option.value !== undefined ? option.title : (option.title + (vuelidate.models[item.name].$params.required ? ' *' : '')) }}
                </option>
              </select>
            </div>

            <!-- checkbox / radio -->
            <label v-else-if="item.attributes.type === 'checkbox' || item.attributes.type === 'radio'"
              v-for="option in item.attributes.options" :key="option.value" :class="[item.attributes.type]">
              <input v-if="item.attributes.type === 'checkbox'" type="checkbox"
                :name="[item.name + '-' + item.value]"
                :disabled="item.attributes.disabled"
                v-model="models[item.name][option.value]"
                @clicked="item.attributes.onChecked()" />
              <input v-else-if="item.attributes.type === 'radio'" type="radio"
                :name="[item.name + '-' + item.value]"
                :disabled="item.attributes.disabled"
                v-model="models[item.name]"
                :value="option.value" />
              <span>{{ option.title }}</span>
            </label>

            <!-- text area -->
            <textarea v-else-if="item.attributes.type === 'textarea'"
              v-model.trim="models[item.name]"
              @input="if(item.attributes.onInput) item.attributes.onInput(models[item.name], item.attributes);"
              :placeholder="[item.attributes.title + (vuelidate.models[item.name].$params.required ? ' *' : '')]"
              :maxlength="item.attributes.maxLength"
              class="textarea"
              :class="[{ 'is-danger': vuelidate.models[item.name].$invalid && vuelidate.models[item.name].$dirty }]" >
            </textarea>

            <!-- text -->
            <label v-else-if="item.attributes.type === 'text'" :class="[item.attributes.type]" :for="item.name">
              <span class="label">{{ item.attributes.title + (vuelidate.models[item.name].$params.required ? ' *' : '') }}</span>
              <input
                v-if="!item.attributes.null"
                v-model="models[item.name]"
                :name="item.name"
                :placeholder="[item.attributes.placeholder || '']"
                :disabled="item.attributes.disabled"
                class="input"
                :class="[{ 'is-danger': vuelidate.models[item.name].$invalid && vuelidate.models[item.name].$dirty }]" /> <!--@input="vuelidate.models.email.$touch()"-->
            </label>

            <!-- label -->
            <p v-else-if="item.attributes.type === 'label'" class="label">
              <span v-html="item.attributes.title" :style="item.attributes.style || {}"></span>
            </p>

            <!-- custom image -->
            <!-- <p v-else-if="item.attributes.type === 'image' && isDesktop" class="image-wrapper" style="text-align:center;">
              <lightbox v-if="!isIE" class="lightbox-wrapper" :caption="''" :src="item.attributes.link" :album="'full_album'">
                <img :src="item.attributes.link" class="img-responsive" />
                <span style="color:gray;font-size:0.8em;">(click to enlarge)</span>
              </lightbox>
              <a v-else class="lightbox-wrapper" :href="item.attributes.link" target="_blank">
                <img :src="item.attributes.link" class="img-responsive" />
                <span style="color:gray;font-size:0.8em;">(click to view in new tab)</span>
              </a>
            </p>
            <p v-else-if="item.attributes.type === 'image' && !isDesktop" class="image-wrapper" style="text-align:center;">
              <a :href="item.attributes.link" target="_blank">
                <img :src="item.attributes.link" class="img-responsive" />
                <span style="color:gray;font-size:0.8em;">(click to view in new tab)</span>
              </a>
            </p> -->
            <p v-else-if="item.attributes.type === 'image'" class="image-wrapper" style="text-align:center;">
              <!-- duplicated control must tally -->
              <a v-if="item.attributes.onClick &&
                typeof item.attributes.onClick === 'function'"
                :href="'#'" @click="$event.preventDefault();item.attributes.onClick()" >
                <img :src="item.attributes.link" class="img-responsive" />
                <span style="color:gray;font-size:0.8em;">{{ item.attributes.title }}</span>
              </a>
              <a v-else-if="item.attributes.link"
                :href="item.attributes.link" target="_blank">
                <img :src="item.attributes.link" class="img-responsive" />
                <span style="color:gray;font-size:0.8em;">{{ item.attributes.title }}</span>
              </a>
            </p>

            <p v-else-if="item.attributes.type === 'button'">
              <button class="btn btn-default" style="cursor:pointer;" @click="item.attributes.onClick(item, models[item.name])"
              :disabled="item.attributes.disabled">
                {{ item.attributes.title }}: {{ models[item.name] }}
              </button>
            </p>

            <!-- invalid -->
            <p v-else class="label">
              Invalid field.
            </p>

            <!-- warn icon -->
            <span v-if="vuelidate.models[item.name].$dirty && vuelidate.models[item.name].$invalid" class="icon is-small is-right is-danger">
              <i class="fa fa-warning"></i>
            </span>
            <small v-if="item.attributes.type === 'text-area'" class="help counter">{{ item.attributes.curLength }} / {{ item.attributes.maxLength }}</small>
            <p v-if="item.attributes.note" class="help is-note" v-html="item.attributes.note" :style="item.attributes.noteStyle" />
            <p v-if="vuelidate.models[item.name].$dirty && vuelidate.models[item.name].$invalid && vuelidate.models[item.name].$params.required && !vuelidate.models[item.name].required" class="help is-danger">required.</p>
            <p v-if="vuelidate.models[item.name].$dirty && vuelidate.models[item.name].$invalid && vuelidate.models[item.name].$params.numeric && !vuelidate.models[item.name].numeric" class="help is-danger">must be numeric value.</p>
            <p v-if="vuelidate.models[item.name].$dirty && vuelidate.models[item.name].$invalid && vuelidate.models[item.name].$params.between && !vuelidate.models[item.name].between" class="help is-danger">must be between {{ vuelidate.models[item.name].$params.between.min }} and {{ vuelidate.models[item.name].$params.between.max }}.</p>
            <p v-if="vuelidate.models[item.name].$dirty && vuelidate.models[item.name].$invalid && vuelidate.models[item.name].$params.minLength && !vuelidate.models[item.name].minLength" class="help is-danger">too short.</p>
            <p v-if="vuelidate.models[item.name].$dirty && vuelidate.models[item.name].$invalid && vuelidate.models[item.name].$params.maxLength && !vuelidate.models[item.name].maxLength" class="help is-danger">is too long.</p>
            <p v-if="vuelidate.models[item.name].$dirty && vuelidate.models[item.name].$invalid && vuelidate.models[item.name].$params.email && !vuelidate.models[item.name].email" class="help is-danger">invalid.</p>
            <p v-if="vuelidate.models[item.name].$dirty && vuelidate.models[item.name].$invalid && vuelidate.models[item.name].$params.hasOwnProperty('required_custom') && !vuelidate.models[item.name].required_custom" class="help is-danger">selection with at least one option.</p>
            <p v-if="vuelidate.models[item.name].$dirty && vuelidate.models[item.name].$invalid && vuelidate.models[item.name].$params.hasOwnProperty('either_custom') && !vuelidate.models[item.name].either_custom" class="help is-danger">selection with conflicting option, please revise.</p>
          </div>
        </div>

      </div>
    </div>

    <!-- <b-field>
      <b-input maxlength="5" type="textarea" placeholder="Message" v-model.trim="message" @input="vuelidate.message.$touch()"></b-input>
    </b-field> -->

    <b-field style="width:100%;margin-bottom:0;" v-if="!isPrint">
      <div class="columns is-gapless is-flex-mobile is-vcentered">
        <div class="column captcha-image-wrapper">
          <vue-recaptcha :sitekey="recaptchaKey" @verify="onVerifyRecaptcha" @expired="onExpiredRecaptcha" @render="onRenderRecaptcha"></vue-recaptcha>
          <input type="hidden" v-model.trim="models['recaptcha']" />
          <p v-if="vuelidate.models['recaptcha'] && vuelidate.models['recaptcha'].$dirty && vuelidate.models['recaptcha'].$invalid && vuelidate.models['recaptcha'].$params.required && !vuelidate.models['recaptcha'].required" class="help is-danger">Invalid recaptcha.</p>
        </div>
      </div>
    </b-field>

    <!-- <b-field style="width:100%;" v-if="!isPrint && false">
      <div class="columns is-gapless is-flex-mobile is-vcentered">
        <div class="column is-narrow captcha-image-wrapper">
          <img class="captcha-image img-responsive" :src="captchaImage" />
        </div>
        <div class="column captcha-text-wrapper">
          <div class="control has-icons-right">
            <label :class="'captcha'">
              <input
                v-model.trim="models['captcha']"
                placeholder="Captcha"
                class="input"
                :class="[{ 'is-danger': vuelidate.models['captcha'].$invalid && vuelidate.models['captcha'].$dirty }]" />
            </label>
          </div>
        </div>
        <div class="column is-4 is-3-mobile" v-if="isDesktop">
          <button class="control button is-outlined" :class="{ 'is-loading': loading }" @click="onSend(vuelidate)">
            <p>{{ loading ? '&nbsp;' : 'SUBMIT' }}</p>
          </button>
        </div>
      </div>
    </b-field> -->

    <b-field class="submit-wrapper" v-if="!isPrint">
      <!-- this must tally with duplicated control -->
      <button class="control button is-outlined" :class="{ 'is-loading': loading }" @click="onSend(vuelidate)">
        <p>{{ loading ? '&nbsp;' : 'SUBMIT' }}</p>
      </button>
    </b-field>

    <p style="text-align:center;" v-if="feedback" class="help is-danger">{{ feedback }}</p>
  </div>
</template>

<script type="text/javascript">
import EventBus from '@/controllers/EventBus'
import DivContainer from '@/components/DivContainer'
import VueRecaptcha from 'vue-recaptcha'
import Site from '@/apis/Site'
import Lightbox from 'vue-lightbox'

export default {
  name: 'section-sign-up-team',
  components: {
    DivContainer,
    Lightbox,
    VueRecaptcha
  },
  watch: {
  },
  props: [
    'type',
    'feedback',
    'loading',
    'names',
    'models',
    'attributes',
    'vuelidate',
    'is-print',
    'is-print-pdf'
  ],
  data: function () {
    return {
      isDesktop: true,
      isIE: EventBus.detectIE(),
      items: [],
      // captcha: '', // use back model's captcha for validation
      captchaImage: undefined,
      session: '',
      recaptchaKey: '6LeaZb0rAAAAALB4GPHaMIetC7nMENnr-KS7kXqP',
      // feedback: false, // capture from external due to send function
      // loading: false,
      navEmail: EventBus._data._navEmail
    }
  },
  created: function () {
    console.log('FormDynamix:created(): $v / models')
    console.log(this.vuelidate)
    console.log(this.models)
    this.init()
  },
  mounted: function () {
    // on event resize
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))

    // this.onRecaptcha(data => {
    //   this.captchaImage = data.data
    //   this.session = data.id
    // })

    console.log('FormDynamix:mounted(): $v / models')
    console.log(this.vuelidate)
    console.log(this.models)
  },
  methods: {
    init: function () {
      console.log('FormDynamix:init()')
      if (this.vuelidate) {
        if (this.vuelidate.models) {
          for (var i = 0; i < this.names.length; i++) {
            var name = this.names[i]
            if (this.vuelidate.models[name]) {
              if (!this.attributes[name]) {
                this.$set(this.attributes, name, {
                  type: 'text',
                  title: 'Invalid'
                })
              }
              if (this.attributes[name] && !this.attributes[name].type) {
                this.attributes[name].type = 'text'
              }
              // if (this.attributes[name] && !this.attributes[name].title) {
              //   this.attributes[name].title = 'Invalid'
              // }

              // text area custom type
              if (this.attributes[name] && this.attributes[name].type === 'textarea') {
                if (!this.attributes[name].hasOwnProperty('onInput')) {
                  this.attributes[name].onInput = function (model, params) {
                    if (model) {
                      params.curLength = model.length
                    }
                  }
                }
                if (!this.attributes[name].curLength) {
                  this.attributes[name].curLength = 0
                }
                if (!this.attributes[name].maxLength) {
                  this.attributes[name].maxLength = 500
                }
              }

              // check box custom type
              if (this.attributes[name] && this.attributes[name].type === 'checkbox') {
              }

              // console.log('initializing:' + name)
              // console.log(this.attributes[name])
              this.$set(this.vuelidate.models[name], 'name', name)
              this.$set(this.vuelidate.models[name], 'attributes', this.attributes[name])
              this.items.push(this.vuelidate.models[name])
            }
          }
        }
      }
    },
    onRecaptcha: function (onRecaptchaSuccess) {
      Site.getRecaptcha()
      .then(data => {
        // console.log('get recaptcha')
        // console.log(data)
        if (onRecaptchaSuccess) {
          onRecaptchaSuccess(data)
        }
      })
      .catch(error => {
        console.log('get recaptcha error')
        console.log(error)
      })
    },
    onRenderRecaptcha: function (id) {
      this.$emit('recaptcha', { status: 'init' })
    },
    onExpiredRecaptcha: function () {
      this.$emit('recaptcha', { status: 'expired' })
    },
    onVerifyRecaptcha: function (response) {
      console.log(response)
      if (response && response.length > 0) {
        this.$emit('recaptcha', { status: 'ok', response: response })
      }
    },
    onResetRecaptcha: function () {
      this.$refs.recaptcha.reset()
      this.$emit('recaptcha', { status: 'reset' })
    },
    onApplicationChanged: function (applicationType) {
      console.log('application type changed: ' + applicationType)
    },
    onSend: function (vuelidate) {
      vuelidate.models.$touch()
      // var _self = this
      // console.log(vuelidate)
      // console.log(this.models)
      this.$emit('send', { vuelidate: vuelidate, models: this.models, session: this.session, captcha: this.models.captcha })
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

$color-darkbrown: black;

.form-dynamix {
  margin-top: 1rem;
  // padding: 0rem 0.75rem;

  // spaces between divs
  margin-left: 15px;
  @media screen and (min-width: $tablet) {
    margin-left: 15px;
  }
  .columns.is-gapless > .column {
    padding-right: 15px;
    @media screen and (min-width: $tablet) {
      padding-right: 15px;
    }
  }

  @media screen and (min-width: $desktop) {
    padding: 0;
  }

  .control {
    margin-bottom: 0;

    &.has-icons-right {
      .icon {
        &.is-danger {
          color: $color-red !important;
        }
      }
    }

    // control label
    .label {
      padding-top: 5px;
      // padding-left: 15px;
      font-size: 0.9rem;
      font-weight: normal;
      color: $color-darkbrown;
    }
    p:not(:last-child) {
      margin-bottom: 0;
    }
  }

  .help {
    padding-left: 15px;
    padding-top: 2px;
    margin-bottom: 2px;

    &.is-danger {
      color: $color-red;
      // &:first-letter {
      //   text-transform: uppercase;
      // }
      // text-transform: lowercase;
    }
  }

  &>p {
    // for feedback field only
    margin-top: 1rem;
    color: $color-gray-mid;
    text-align: center;
    font-weight: bold;
    @media screen and (min-width: $desktop) {
      text-align: left;
    }
  }

  // span {
  //   display: block;
  // }

  .captcha-image-wrapper {
    .captcha-image {
      height: 3.6em;
      margin-top: 15px;
      margin-bottom: 0px;
    }

    text-align: center;

    & > div {
      margin: auto;
      margin-top: 30px;
      // margin-left: 0;
      & > div {
        margin: auto;
        // margin-left: 0px;
        // @media screen and (min-width: $desktop) {
        //   margin-left: 30px;
        // }
      }
    }
  }
  .captcha-text-wrapper {
    padding-right: 0px;
    @media screen and (min-width: $desktop) {
      padding-right: 15px;
    }
  }

  .submit-wrapper {
    width: 100%;
    margin: auto;
    padding-right: 15px;
    @media screen and (min-width: $desktop) {
      width: 50%;
      padding-right: 15px;
    }
  }

  input, textarea, select {
    // border: 0;
    font-size: 0.8em;
    box-shadow: none;
    background-color: white;
    border: 1px solid #bbbbbb;

    height: 3em;
    padding-left: 15px;
    padding-right: 15px;

    &[name='captcha'] {
      padding-left: 5px;
      padding-right: 5px;
      @media screen and (min-width: $desktop) {
        padding-left: 15px;
        padding-right: 15px;
      }
    }

    &::placeholder {
      color: #999999;
    }
    &:focus, &.is-focused, &:active, &.is-active {
      border-color: $color-black;
    }

    &.is-danger {
      border-color: $color-red;
    }

    &[disabled] {
      background-color: $color-gray-light;
    }
  }

  .select {
    width: 100%;
    select {
      width: 100%;
    }
  }

  textarea {
    height: auto;
    @media screen and (min-width: $tablet) {
      height: 120px;
    }
  }

  button {
    border-radius: 0;
    // border: 2px solid $color-gray-mid;
    font-size: 0.8em;
    font-weight: bold;
    background-color: $color-orange;
    width: 100%;
    height: auto;
    padding-top: 12px;
    padding-bottom: 12px;
    -webkit-transition: all 0.2s ease-in-out 0s;
    transition: all 0.2s ease-in-out 0s;
    opacity: 1;
    flex-direction: column;

    & p {
      color: $color-black;
    }

    &:after {
      border-color: $color-gray-mid;
      border-right-color: transparent;
      border-top-color: transparent;
    }

    @media screen and (min-width: $desktop) {
      // width: 150px;
      // height: auto;
      // padding-top: 12px;
      // padding-bottom: 12px;
    }

    &:hover {
      background-color: $color-gray;
      -webkit-transition: all 0.2s ease-in-out 0s;
      transition: all 0.2s ease-in-out 0s;
      & p {
        color: #fff;
      }
    }

    &[disabled] {
      background-color: $color-gray-light;
    }
  }

  .checkbox, .radio {
    color: $color-darkbrown;
    font-size: 1em;

    input[type=checkbox], input[type=radio] {
      height: 24px;
      display: inline-block;
      vertical-align: middle;
      margin: 2px 2px 2px 3em;
    }

    &.default {
      input[type=checkbox] {
        margin: 2px 2px 2px 0px;
      }
    }

    span {
      font-size: 0.9em;
    }
  }
}
</style>



// WEBPACK FOOTER //
// FormDynamix.vue?27a3c121